<!-- Header section -->
<div [hidden]="showFlowBuilder">
    <cv-loader [loaderType]="'cxone'" *ngIf="showSpinner"></cv-loader>
    <div class="row common-container col-sm-12 col-md-12 cx-one-ui">
        <div class="col-sm-6">
            <div class="reporting-set">
                <button class="btn btn-link" id="reporting-set-button" cvLocalizedText langSection="ETL_Reporting_Set"
                    langKey="Reporting_Set" (click)="changeSection(reportingSetSections.LIST)">Reporting set</button>
                <h3 class="create-reporting-set-Text" id="cteate-reporting-set">{{reportingSetPageTitle}}</h3>
            </div>
        </div>

        <div class="col-sm-6 buttons-list">
            <button class="cxone-btn btn-big btn-secondary btn-bg-is-white" id="cancel-button" cvLocalizedText
                langSection="ETL_Reporting_Set" langKey="Cancel"
                (click)="changeSection(reportingSetSections.LIST)">Cancel</button>
            <button *ngIf="saveBtnVisible" class="cxone-btn btn-big btn-secondary btn-bg-is-white" id="save-button"
                [disabled]="!reportingSetForm.valid" cvLocalizedText langSection="ETL_Reporting_Set" langKey="Save"
                (click)="saveReportingSet()">Save</button>
            <button class="cxone-btn btn-big btn-primary btn-bg-is-white" id="next-button"
                [disabled]="!reportingSetForm.valid || forbiddenCharError || charLimitReportNameError || reportingSetNameExist"
                cvLocalizedText langSection="ETL_Reporting_Set" langKey="Next"
                (click)="showHideFlowBuilder(true)">Next</button>
        </div>
    </div>

    <!-- Form-section -->
    <div class="main-section cx-one-ui" *ngIf="showEditReportingSet">
        <div class="form-container cx-one-ui">
            <form [formGroup]="reportingSetForm" id="reporting-set-create">

                <!-- Reporting Set Name Field -->
                <div class="input-field reporting-set-field-width">
                    <label for="report-name-field" id="reporting-set-name-label" cvLocalizedText
                        langSection="ETL_Reporting_Set" langKey="Reporting_Set_Name">Reporting Set Name
                    </label> <span class="field-required"> * </span>
                    <cxone-text-input type="text" formControlName="reportingSetName" class="report-text-input"
                        [class.ng-invalid]="forbiddenCharError || charLimitReportNameError || reportingSetNameExist || !reportNameExist"
                        [class.ng-valid]="!forbiddenCharError && !charLimitReportNameError && !reportingSetNameExist && !reportNameExist"
                        (keyup)="reportingSetNameDuplicateValidation($event)" id="report-name-field"
                        [placeholder]="enterReportingSetName"></cxone-text-input>
                    <div class="report-name-error" id="reporting-name-char-limit" *ngIf="charLimitReportNameError"
                        cvLocalizedText langSection="ETL_Reporting_Set" langKey="Character_Limit">Enter up to 100
                        characters
                    </div>
                    <div class="report-name-error" id="reporting-name-forbidden-char" *ngIf="forbiddenCharError"
                        cvLocalizedText langSection="ETL_Reporting_Set" langKey="Special_Characters">Cannot use
                        ^ / ! \ \ + <> ? # & &#64; , "</div>
                    <div class="report-name-error" id="reporting-name-exist" *ngIf="reportingSetNameExist"
                        cvLocalizedText langSection="ETL_Reporting_Set" langKey="Reporting_Set_Name_Exist">Reporting set
                        name already exists
                    </div>
                </div>

                <!-- Description Field -->
                <div class="input-field reporting-set-description-feild">
                    <label for="description-field" id="description-label" cvLocalizedText
                        langSection="ETL_Reporting_Set" langKey="Description">Description</label>
                    <cxone-text-area formControlName="description" id="description-field"
                        [placeholder]="reportDescription" (input)="descriptionFieldCharCount()">
                    </cxone-text-area>
                    <div>
                        <div class="report-description-error" id="description-char-limit-error"
                            *ngIf="charLimitDescriptionError" cvLocalizedText langSection="ETL_Reporting_Set"
                            langKey="Description_Limit">This entry is too long.
                        </div>
                        <div class="description-char-count" id="description-char-count"
                            [ngClass]="charLimitDescriptionError ? 'description-char-limit-exceeds' : 'description-char-limit'">
                            {{descriptionCharCount}}/1000
                        </div>
                    </div>
                </div>

                <!-- Category Field -->
                <div class="input-field reporting-set-field-width">
                    <label for="category-dropdown" id="category-label" cvLocalizedText langSection="ETL_Reporting_Set"
                        langKey="Category">Category </label><span class="field-required"> * </span>
                    <cxone-singleselect-dropdown id="category-dropdown" formControlName="category"
                        [options]="categoryOptions" [showFooter]="false" [sortOrder]="'asc'"
                        [enableAddFreeTextItem]="true" (onCreate)="onCreate($event)"
                        [placeholder]="dropdownPlaceholderText">
                    </cxone-singleselect-dropdown>
                </div>

                <!-- Base Feed Fields -->
                <div class="input-field reporting-set-field-width">
                    <label for="basefeed-dropdown" id="basefeed-label" cvLocalizedText langSection="ETL_Reporting_Set"
                        langKey="Base_Feed">Base Feed </label><span class="field-required"> * </span>
                    <cxone-singleselect-dropdown id="basefeed-dropdown" [label]="'FeedName'" [primaryKey]="'_id'"
                        [options]="basefeedOptions" [showFooter]="false" formControlName="basefeed" [sortOrder]="'asc'"
                        [placeholder]="dropdownPlaceholderText">
                    </cxone-singleselect-dropdown>
                </div>
            </form>

            <!-- Add Simple Fields Section -->
            <div class="add-simple-fields-group" *ngIf="reportingSetPageTitle == 'Create Reporting Set'">
                <div id="simple-field-text-icon-container">
                    <h4 class="add-simple-fields" id="add-simple-fields" cvLocalizedText langSection="ETL_Reporting_Set"
                        langKey="Add_Simple_Fields">Add Fields </h4>
                    <span id="more-info-icon" placement="top" [ngbPopover]="infoTooltip" container=".cx-one-ui"
                        triggers="mouseenter:mouseleave">
                        <svg class="icon-16">
                            <use href="../App_Themes/CXone/icons/info.svg#info"></use>
                        </svg>
                    </span>
                    <ng-template #infoTooltip>
                        <span cvLocalizedText langSection="ETL_Reporting_Set" langKey="Fields_ToolTip">
                            Select any fields from the Raw Data that you want to include without changes.
                            Dates will be placed in the Dates collection, while
                            other types will go into the Data Fields.
                        </span>
                    </ng-template>
                </div>

                <button class="cxone-btn btn-secondary btn-bg-is-white" id="add-fields-button"
                    [disabled]="!reportingSetForm.valid || (reportingSetPageTitle != 'Create Reporting Set' && simpleFieldsExists)"
                    cvLocalizedText langSection="ETL_Reporting_Set" langKey="Add_Fields"
                    (click)="showSimpleFieldsModal()">Add</button>
            </div>
            <div id="basefeed-grid-container" *ngIf="showGrid && reportingSetPageTitle == 'Create Reporting Set'">
                <cxone-grid [gridOptions]="gridOptions" id="baseFeed-grid"
                    *ngIf="gridOptions && gridOptions.hasOwnProperty('columnDefs')">
                </cxone-grid>
            </div>
        </div>
    </div>
</div>
<ng-container *ngIf="reportingSetDef && rowData">
    <cv-cxone-reporting-set-flow-builder [isShowFlowBuilder]="!showFlowBuilder" [reportingSetForm]="reportingSetDef" (sectionChange)="changeSection($event)"
    [dataFieldsList]="rowData" [updateBtnVisiblity]="editForm"></cv-cxone-reporting-set-flow-builder>
</ng-container>